import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React from 'react';
import CloseIcon from '../../../icons/CloseIcon.jsx';

export function RBACDialog({
  handleDialog,
  dialogOpen,
  form,
  setForm,
  handleCreate,
  error,
  loading,
  heading,
  data
}) {
  return (
    <Dialog
      onClose={handleDialog}
      aria-labelledby='simple-dialog-title'
      open={dialogOpen}
      className='w-full'
      fullWidth={true}
    >
      <DialogTitle id='simple-dialog-title'>{heading}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <form>
            <div
              className='absolute right-6 top-4 cursor-pointer'
              onClick={handleDialog}
            >
              <CloseIcon />
            </div>
            <div className='flex justify-between'>
              <span className='flex flex-col w-full mr-4'>
                <label>Name</label>
                <input
                  disabled={data?.userDetail}
                  className='border border-solid  mb-3 outline-none p-1 rounded h-10'
                  style={{
                    borderColor: '#8692A6',
                  }}
                  type='text'
                  name='name'
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder='Enter name'
                />
              </span>
              <span className='flex flex-col w-full'>
                <label>Email</label>
                <input
                  disabled={data?.userDetail}
                  className='border border-solid  mb-3 outline-none p-1 rounded h-10'
                  style={{
                    borderColor: '#8692A6',
                  }}
                  type='text'
                  name='email'
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder='Enter email'
                />
              </span>
            </div>
            <div className='flex justify-between'>
              <span className='flex flex-col w-full mr-4'>
                <label>Referral Amount</label>
                <input
                  className='border border-solid  mb-3 outline-none p-1 rounded h-10'
                  style={{
                    borderColor: '#8692A6',
                  }}
                  type='number'
                  name='referralAmount'
                  value={form.referralAmount}
                  onChange={(e) =>
                    setForm({ ...form, referralAmount: e.target.value })
                  }
                  placeholder='Enter referral amount'
                />
              </span>
              <span className='flex flex-col w-full'>
                <label>User Group</label>
                <input
                  className='border border-solid  mb-3 outline-none p-1 rounded h-10'
                  style={{
                    borderColor: '#8692A6',
                  }}
                  type='text'
                  name='userGroup'
                  value={form.userGroup}
                  onChange={(e) =>
                    setForm({ ...form, userGroup: e.target.value })
                  }
                  placeholder='Enter user group'
                />
              </span>
            </div>
            <div className='flex justify-between'>
              <span className='flex flex-col w-full mr-4'>
                <label>UTM Source</label>
                <input
                  className='border border-solid  mb-3 outline-none p-1 rounded h-10'
                  style={{
                    borderColor: '#8692A6',
                  }}
                  type='text'
                  name='utmSource'
                  value={form.utm_source}
                  onChange={(e) =>
                    setForm({ ...form, utm_source: e.target.value })
                  }
                  placeholder='Enter UTM Source'
                />
              </span>
              <span className='flex flex-col w-full'>
                <label>UTM Medium</label>
                <input
                  className='border border-solid  mb-3 outline-none p-1 rounded h-10'
                  style={{
                    borderColor: '#8692A6',
                  }}
                  type='text'
                  name='utmMedium'
                  value={form.utm_medium}
                  onChange={(e) =>
                    setForm({ ...form, utm_medium: e.target.value })
                  }
                  placeholder='Enter UTM Medium'
                />
              </span>
            </div>
            <div className='flex justify-between'>
              <span className='flex flex-col w-full mr-4'>
                <label>UTM Campaign</label>
                <input
                  className='border border-solid  mb-3 outline-none p-1 rounded h-10'
                  style={{
                    borderColor: '#8692A6',
                  }}
                  type='text'
                  name='utmCampaign'
                  value={form.utm_campaign}
                  onChange={(e) =>
                    setForm({ ...form, utm_campaign: e.target.value })
                  }
                  placeholder='Enter UTM Campaign'
                />
              </span>
              <span className='flex flex-col w-full'>
                <label>UTM Term</label>
                <input
                  className='border border-solid  mb-3 outline-none p-1 rounded h-10'
                  style={{
                    borderColor: '#8692A6',
                  }}
                  type='text'
                  name='utmTerm'
                  value={form.utm_term}
                  onChange={(e) =>
                    setForm({ ...form, utm_term: e.target.value })
                  }
                  placeholder='Enter UTM Term'
                />
              </span>

            </div>
            <div className='flex justify-between'>
              <span className='flex flex-col w-full mr-4'>
                <label>UTM Content</label>
                <input
                  className='border border-solid  mb-3 outline-none p-1 rounded h-10'
                  style={{
                    borderColor: '#8692A6',
                  }}
                  type='text'
                  name='utmContent'
                  value={form.utm_content}
                  onChange={(e) =>
                    setForm({ ...form, utm_content: e.target.value })
                  }
                  placeholder='Enter UTM Content'
                />
              </span>
              <span className='flex flex-col w-full' />
            </div>
            <div className='flex justify-center mt-10'>
              <Button
                disabled={loading}
                variant='contained'
                color='primary'
                style={{
                  padding: '10px 25px',
                }}
                onClick={handleCreate}
              >
                Generate Referral Url
              </Button>
            </div>
          </form>
        </DialogContentText>
        <span className='text-sm text-red-500 mb-4 inline-block'>{error}</span>
      </DialogContent>
    </Dialog>
  );
}
